import React from "react"
import styled from "styled-components"

export default function Privacy() {
  const date = new Date().getFullYear()
  return (
    <Wrapper>
      <p className="website">www.rustichomesteadchile.com</p>
      <div className="content">
        <span>Developed by&nbsp;</span>
        <a href="#!">Aljorgevi</a> &copy;{date}
        <span>. All rights reserved.</span>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  font-size: 0.55rem;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  padding: 5rem 0.5rem 2rem 0.5rem;
  .website {
    margin: 1rem auto;
  }
  @media screen and (min-width: 992px) {
    .website {
      margin: inherit;
    }
  }
`
